import _regenerator from "/usr/app/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/usr/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _defineProperty from "/usr/app/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import React from "react";
var __jsx = React.createElement;
import useHelpers from "@hooks/useHelpers";
import useIsMobile from "@hooks/useIsMobile";
import { useTranslation } from "@i18n";
import Layout from "@/_LayoutsRelated/layout/Layout";
import DhamenFormScreen from "@/pages/checkout/dhamen/components/DhamenFormScreen/DhamenFormScreen";
import AcceptedOffer from "@/pages/checkout/dhamen/components/AcceptedOffer";
import OfferRejectedByDhamen from "@/pages/checkout/dhamen/components/OfferRejectedByDhamen";
import OfferRejectedByUser from "@/pages/checkout/dhamen/components/OfferRejectedByUser";
import OfferExpired from "@/pages/checkout/dhamen/components/OfferExpired";
import InitialOfferScreen from "@/pages/checkout/dhamen/components/InitialOfferScreen";
import ActiveOfferScreen from "@/pages/checkout/dhamen/components/ActiveOfferScreen";
import { useDhamenContext } from "@/common/Contexts/DhamenContextProvider";
import { DHAMEN_STATUS } from "@/pages/checkout/dhamen/constants";
import Loader from "@componentsShared/Loader/Loader";
import { useEffect } from "react";
import { getPlatformInfo } from "@/utils/GlobalJavascriptFunction";
import { trackEvents } from "@/common/events/events";
import MobileHeader from "@/pages/checkout/dhamen/components/DhamenFormScreen/MobileHeader";
import InfoModal from "@/pages/checkout/dhamen/components/common/InfoModal";
import WarningIcon from "@/pages/checkout/dhamen/icons/WarningIcon";
function DhamenFlowPage(props) {
  var _statusComponentMap, _state$orderInfo4, _state$orderInfo4$ord;
  var isMobile = useIsMobile();
  var _useDhamenContext = useDhamenContext(),
    state = _useDhamenContext.state,
    actions = _useDhamenContext.actions;
  var _useHelpers = useHelpers(),
    navigateTo = _useHelpers.navigateTo;
  var statusComponentMap = (_statusComponentMap = {}, _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_statusComponentMap, DHAMEN_STATUS.NEW, /*#__PURE__*/React.createElement(DhamenFormScreen, null)), DHAMEN_STATUS.REVISED, /*#__PURE__*/React.createElement(DhamenFormScreen, {
    initialTab: "finance-form"
  })), DHAMEN_STATUS.ACCEPTED, /*#__PURE__*/React.createElement(ActiveOfferScreen, null)), DHAMEN_STATUS.ACCEPTED_ACTION, /*#__PURE__*/React.createElement(AcceptedOffer, null)), DHAMEN_STATUS.SUBMITTED, /*#__PURE__*/React.createElement(InitialOfferScreen, null)), DHAMEN_STATUS.EXPIRED, /*#__PURE__*/React.createElement(OfferExpired, null)), DHAMEN_STATUS.DECLINED_ACTION, /*#__PURE__*/React.createElement(OfferRejectedByUser, null)), DHAMEN_STATUS.DECLINED, /*#__PURE__*/React.createElement(DhamenFormScreen, null)), DHAMEN_STATUS.REJECTED, /*#__PURE__*/React.createElement(OfferRejectedByDhamen, null)), DHAMEN_STATUS.FUNDED, /*#__PURE__*/React.createElement(ActiveOfferScreen, null)), _defineProperty(_defineProperty(_statusComponentMap, DHAMEN_STATUS.APPROVED, /*#__PURE__*/React.createElement(ActiveOfferScreen, null)), DHAMEN_STATUS.PENDING, /*#__PURE__*/React.createElement(ActiveOfferScreen, null)));
  useEffect(function () {
    var _state$orderInfo, _state$orderInfo$orde;
    if (state !== null && state !== void 0 && (_state$orderInfo = state.orderInfo) !== null && _state$orderInfo !== void 0 && (_state$orderInfo$orde = _state$orderInfo.order) !== null && _state$orderInfo$orde !== void 0 && _state$orderInfo$orde.order_uuid) {
      var _state$orderInfo2, _state$orderInfo2$ord, _state$orderInfo3;
      trackEvents("dhamen_link_open", {
        order_id: state === null || state === void 0 ? void 0 : state.orderInfo.order.id,
        post_id: state.orderInfo.order.post_id,
        transaction_id: state === null || state === void 0 ? void 0 : (_state$orderInfo2 = state.orderInfo) === null || _state$orderInfo2 === void 0 ? void 0 : (_state$orderInfo2$ord = _state$orderInfo2.order) === null || _state$orderInfo2$ord === void 0 ? void 0 : _state$orderInfo2$ord.order_uuid,
        post_price: state === null || state === void 0 ? void 0 : (_state$orderInfo3 = state.orderInfo) === null || _state$orderInfo3 === void 0 ? void 0 : _state$orderInfo3.order.post_details.price,
        platform: getPlatformInfo()
      });
    }
  }, [state === null || state === void 0 ? void 0 : (_state$orderInfo4 = state.orderInfo) === null || _state$orderInfo4 === void 0 ? void 0 : (_state$orderInfo4$ord = _state$orderInfo4.order) === null || _state$orderInfo4$ord === void 0 ? void 0 : _state$orderInfo4$ord.order_uuid]);
  var getCurrentStep = function getCurrentStep(status) {
    var _statusComponentMap$s;
    return (_statusComponentMap$s = statusComponentMap[status]) !== null && _statusComponentMap$s !== void 0 ? _statusComponentMap$s : /*#__PURE__*/React.createElement(DhamenFormScreen, null);
  };
  var _useTranslation = useTranslation(["web_checkout_finance"]),
    t = _useTranslation.t,
    tShort = _useTranslation.tShort;
  return /*#__PURE__*/React.createElement(Layout, {
    hideHeaderOnmobile: state.status == DHAMEN_STATUS.NEW || state.status == DHAMEN_STATUS.REVISED || state.status == DHAMEN_STATUS.SUBMITTED,
    hideFooterWithoutAuthMsg: false,
    custommobileHeader: isMobile && (state.status == DHAMEN_STATUS.SUBMITTED || state.status == DHAMEN_STATUS.NEW || state.status == DHAMEN_STATUS.REVISED) && /*#__PURE__*/React.createElement(MobileHeader, {
      hideBack: !(state.status === DHAMEN_STATUS.SUBMITTED || (state.status === DHAMEN_STATUS.NEW || state.status === DHAMEN_STATUS.REVISED) && state.activeTab === "finance-form"),
      hideCancel: state.status === DHAMEN_STATUS.SUBMITTED,
      onBack: actions.handleBackClick,
      onClose: actions.toggleClosingModal,
      title: state.status === DHAMEN_STATUS.SUBMITTED ? tShort("dhamen/initial_offer_header") : tShort("dhamen/instant_cash_financing")
    }),
    disableLoader: true,
    authenticationMsg: true,
    hideAppBanner: true,
    linksForSearch: true,
    headHideLinks: true,
    hideOrangeHeadBtn: true
  }, state.loading ? /*#__PURE__*/React.createElement("div", {
    className: "min-h-[500px] flex justify-center items-center"
  }, /*#__PURE__*/React.createElement(Loader, {
    smallLoader: true
  })) : state.error ? /*#__PURE__*/React.createElement("div", {
    className: "flex justify-center items-center min-h-[400px]"
  }, /*#__PURE__*/React.createElement("div", {
    className: "text-center text-red-500"
  }, /*#__PURE__*/React.createElement("button", {
    className: "blueBtn mt-4",
    onClick: function onClick() {
      return actions.refetchOrderInfo();
    }
  }, t("try_again", {
    ns: "web_common"
  })))) : /*#__PURE__*/React.createElement(React.Fragment, null, getCurrentStep(state.status)), /*#__PURE__*/React.createElement(InfoModal, {
    icon: /*#__PURE__*/React.createElement(WarningIcon, null),
    primaryButton: {
      onClick: function onClick() {
        actions.hideClosingModal();
      },
      label: t("continue_application", {
        ns: "web_tracking"
      })
    },
    secondaryButton: {
      label: t("cancel_submitting_application", {
        ns: "web_tracking"
      }),
      onClick: function () {
        var _onClick = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
          var _state$orderInfo5, _state$orderInfo5$ord, _state$orderInfo6, _state$orderInfo6$ord, _state$orderInfo7;
          return _regenerator().w(function (_context) {
            while (1) switch (_context.n) {
              case 0:
                trackEvents("dhamen_form_quit", {
                  order_id: state === null || state === void 0 ? void 0 : (_state$orderInfo5 = state.orderInfo) === null || _state$orderInfo5 === void 0 ? void 0 : (_state$orderInfo5$ord = _state$orderInfo5.order) === null || _state$orderInfo5$ord === void 0 ? void 0 : _state$orderInfo5$ord.id,
                  post_id: state.orderInfo.order.post_id,
                  transaction_id: state === null || state === void 0 ? void 0 : (_state$orderInfo6 = state.orderInfo) === null || _state$orderInfo6 === void 0 ? void 0 : (_state$orderInfo6$ord = _state$orderInfo6.order) === null || _state$orderInfo6$ord === void 0 ? void 0 : _state$orderInfo6$ord.order_uuid,
                  post_price: state === null || state === void 0 ? void 0 : (_state$orderInfo7 = state.orderInfo) === null || _state$orderInfo7 === void 0 ? void 0 : _state$orderInfo7.order.post_details.price,
                  platform: getPlatformInfo()
                });
                navigateTo("/");
              case 1:
                return _context.a(2);
            }
          }, _callee);
        }));
        function onClick() {
          return _onClick.apply(this, arguments);
        }
        return onClick;
      }()
    },
    text: t("information_saved_need_refill_data", {
      ns: "web_tracking"
    }),
    onClose: function onClose() {
      return actions.hideClosingModal();
    },
    open: state.showClosingModal,
    toggle: actions.hideClosingModal,
    title: t("sure_cancel_application", {
      ns: "web_tracking"
    })
  }));
}
export default DhamenFlowPage;